import { Component, ChangeDetectionStrategy } from '@angular/core';

import { BaseFormInput } from '../base-form-input';

@Component({
    selector: 'nuso-readonly-textarea-input',
    templateUrl: './readonly-textarea-input.component.html',
    styleUrls: ['./readonly-textarea-input.component.css'],
    standalone: false
})
export class ReadonlyTextareaInputComponent extends BaseFormInput {
}
